export default __webpack_public_path__ + "1b810e7b8a02849bd029542a632cc621.png";